/**
 * @param {object} obj1 source object for comparison
 * @param {object} obj2 target object for comparison
 *
 * @returns {boolean}  Returns true if the values are equivalent, else false.
 */

const deepCompareObjects = (obj1, obj2) => {
  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);

  if (obj1Keys.length !== obj2Keys.length) return false;

  for (const objKey of obj1Keys) {
    if (obj1[objKey] !== obj2[objKey]) {
      if (typeof obj1[objKey] == 'object' && typeof obj2[objKey] == 'object') {
        if (!deepCompareObjects(obj1[objKey], obj2[objKey])) return false;
      } else return false;
    }
  }

  return true;
};
export default deepCompareObjects;
